import * as React from 'react';
import "./Contents.scss";
import { useMemo, useState, useEffect, createContext, useCallback } from 'react';
import { PersonsProps } from '../../interface/IPerson';
import Body from '../body/Body';
import { ContentsDefines, ContentsProps, OnBeforeNextStepListener } from './IContents';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { ProgressProps } from '../progress/IProgress';
import { ColorDefines } from '../../interface/IColors';
import { selectColorCode } from '../../util/selectColorCode';

export const UserDataContext = createContext<{ [key: string]: any }>({});

interface ContentsProp {
  props: ContentsProps;
  defines: ContentsDefines;
  colors?: ColorDefines;

  children: JSX.Element|JSX.Element[];
}
const Contents = ({ props, defines, colors, children }: ContentsProp) => {
  return (
    <div className="contents" style={{
      gridTemplateRows: props.gridTemplateRows,
      backgroundColor: colors?.secondary ? colors.secondary : "#eeeeee",
      ...(defines.style || {})
    }}>
      {children}
    </div>
  )
};

export default Contents;
